promokit.layer({
    el: '#layer-privacy',
    buttons: '#p-check-privacy + label > button'
});
promokit.layer({
    el: '#layer-ad',
    buttons: '#p-check-ad + label > button'
});
promokit.layer({
    el: '#layer-cloth',
    buttons: '.p-sec3__btn--cloth'
});
promokit.layer({
    el: '#layer-rock',
    buttons: '.p-sec3__btn--rock'
});
promokit.layer({
    el: '#layer-start',
    buttons: '.p-sec3__btn--start'
});
window.layer_event_end = promokit.layer({
    el: '#layer-event-end',
});
window.layer_preorder_complete = promokit.layer({
    el: '#layer-preorder-complete',
});

$(document).on('click', '.p-preorder__sns', function(e){
    e.preventDefault();
    promokit.share({
        target:$(this)[0].innerHTML
    });
});

$(document).on('click', '.p-mycoupon__btn, .p-sec4__btn--coupon', function(e) {
    e.preventDefault();
    promokit.coupon();
});

window.callTime = {
    variables: {
        _time: false,
        _seconds: 300
    },
    start(){
        $('.p-form__num--certi span').text('05:00');
        callTime.variables['_time'] = setInterval(function () {
            callTime.variables['_seconds']--;
            var min = '0' + parseInt(callTime.variables['_seconds']/60);
            var sec = callTime.variables['_seconds'] % 60;
            if(sec < 10) sec = '0' + sec;
            $('.p-form__num--certi span').text(min + ':' + sec);
            if( callTime.variables['_seconds'] <= 0 ) {
                callTime.stop();
            }
        },1000);
    },
    stop(){
        clearInterval(callTime.variables['_time']);
        $('.p-form__num--certi span').text('');
        callTime.variables['_seconds'] = 300;
    }
};

$(document).on('click','.p-mycoupon__copy',function () {
    var $mycoupon = $('.p-mycoupon__num')[0].innerHTML;
    if(!($mycoupon === '---------------')){
        var aux = document.createElement("input");
        aux.setAttribute("value", $mycoupon);
        document.body.appendChild(aux);
        aux.select();
        document.execCommand("copy");
        document.body.removeChild(aux);
        promokit.message({
            type: 'alert',
            message: '쿠폰 번호가 복사되었습니다.'
        });
    }
});

promokit.slide({
    el: '#p-slide',
    arrow: true,
    bullet: true
});
promokit.layer({
    el: '#p-layer-player-1',
    buttons: '.p-sec5__thumb--1 button',
    player: {
        youtubeId: 'l4AopD46IlE',
        loop: true,
        controls: true,
        youtubeLink: true
    },
});
promokit.layer({
    el: '#p-layer-player-2',
    buttons: '.p-sec5__thumb--2 button',
    player: {
        youtubeId: 'MT6PQRAx7Ww',
        loop: true,
        controls: true,
        youtubeLink: true
    },
});
promokit.layer({
    el: '#p-layer-player-3',
    buttons: '.p-sec5__thumb--3 button',
    player: {
        youtubeId: 'cLmoOa9G5vc',
        loop: true,
        controls: true,
        youtubeLink: true
    },
});
promokit.layer({
    el: '#p-layer-player-4',
    buttons: '.p-sec5__thumb--4 button',
    player: {
        youtubeId: 'mh75kod-MM8',
        loop: true,
        controls: true,
        youtubeLink: true
    },
});
promokit.layer({
    el: '#p-layer-player-5',
    buttons: '.p-sec5__thumb--5 button',
    player: {
        youtubeId: 'AILe4C4EodM',
        loop: true,
        controls: true,
        youtubeLink: true
    },
});
promokit.layer({
    el: '#p-layer-player-6',
    buttons: '.p-sec5__thumb--6 button',
    player: {
        youtubeId: 'VIMHRRHEB8s',
        loop: true,
        controls: true,
        youtubeLink: true
    },
});
promokit.layer({
    el: '#p-layer-player-7',
    buttons: '.p-sec5__thumb--7 button',
    player: {
        youtubeId: 'L21EyBytnVs',
        loop: true,
        controls: true,
        youtubeLink: true
    },
});

$('.p-form__num > input').on('input',function () {
    if(this.value.length > 6) this.value = this.value.slice(0, 6);
});
$('.p-form__num--phone').on('input',function () {
    if(this.value.length > 11) this.value = this.value.slice(0, 11);
});


// WEBPACK FOOTER //
// ./src/js/common.js